import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { PercentInput, MoneyInput, IntegerInput, DatePicker } from "components/Global/FormikMaterial";

const StyledDatePicker = styled(DatePicker)`
  & {width:100%;}
`;
const StyledIntegerInput = styled(IntegerInput)`
  & {width:100%;}
`;
const StyledMoneyInput = styled(MoneyInput)`
  & {width:100%;}
`;
const StyledPercentInput = styled(PercentInput)`
  & {width:100%;}
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;
const WithQuoteFormVariant = ({ }) => (
  <>
    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
      <StyledMoneyInput
        label={<StyledLabel>{"Notional"}</StyledLabel>}
        fieldName="loanAmount"
      />
    </Grid>
    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
      <StyledDatePicker
        label={<StyledLabel>{"Start Date"}</StyledLabel>}
        fieldName="startDate"
      />
    </Grid>
    <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
      <StyledIntegerInput
        label={<StyledLabel>{"Term (m)"}</StyledLabel>}
        fieldName="loanTerm"
      />
    </Grid>
    <Grid item xs={12} />
    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
      <StyledPercentInput
        label={<StyledLabel>{"Loan Spread (%)"}</StyledLabel>}
        decimalScale={3}
        fieldName="spread"
      />
    </Grid>
    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
      <StyledPercentInput
        label={<StyledLabel>{"Bank Quote (%)"}</StyledLabel>}
        decimalScale={3}
        fieldName="allInRate"
      />
    </Grid>
  </>
);
export default WithQuoteFormVariant;
